import classNames from 'classnames';
import { ReactNode } from 'react';
import styles from './styles.module.scss';
import attention from './attention.svg';

export const Alert: React.FC<{ type: 'error', children?: ReactNode }> = ({ type, children }) => {
  return <>
    <div className={classNames(styles.container, styles[`type-${type}`])}>
      <img src={attention} />
      <>
        {children}
      </>
    </div>
  </>;
}